import * as THREE from "three";
import backgroundEXR from "/assets/background.exr?url";
import { EXRLoader } from "three/examples/jsm/loaders/EXRLoader.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { Camera } from "./Camera";
import { Lights } from "./Lights"

export class Environment {
  constructor(store, scene, renderer) {
    this.store = store;
    this.scene = scene;
    this.renderer = renderer;
    this.camera = new Camera(this.store);
    this.lights = new Lights(this.scene);
    this.controls = new OrbitControls(this.camera.camera, this.renderer.domElement);
    this.controls.enableDamping = true;
    this.store.config.isMobile = this.detectMobile();
    this.createOrientationOverlay();
    this.loadHDRI();
  }

  update(delta) {
    this.camera.update(this.controls);
  }

  loadHDRI() {
    const loader = new EXRLoader();

    loader.load(backgroundEXR, (texture) => {
      texture.mapping = THREE.EquirectangularReflectionMapping;
      const pmrem = new THREE.PMREMGenerator(this.renderer);
      const envMap = pmrem.fromEquirectangular(texture).texture;
      this.scene.environment = envMap;
      this.scene.background = envMap;
      this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
      this.renderer.toneMappingExposure = 0.6;
      this.renderer.outputColorSpace = THREE.SRGBColorSpace;
      texture.dispose();
      pmrem.dispose();
    });
  }

  detectMobile() {return window.innerWidth <= 768;}

 createOrientationOverlay() {
  this.orientationOverlay = document.createElement("div");
  this.orientationOverlay.style.position = "fixed";
  this.orientationOverlay.style.inset = "0";
  this.orientationOverlay.style.background = "#000";
  this.orientationOverlay.style.color = "#fff";
  this.orientationOverlay.style.display = "flex";
  this.orientationOverlay.style.alignItems = "center";
  this.orientationOverlay.style.justifyContent = "center";
  this.orientationOverlay.style.fontSize = "28px";
  this.orientationOverlay.style.fontWeight = "700";
  this.orientationOverlay.style.zIndex = "99999";
  this.orientationOverlay.style.textAlign = "center";
  this.orientationOverlay.innerHTML = "Kérlek fordítsd el a készüléket fekvő helyzetbe";
  document.body.appendChild(this.orientationOverlay);
  this.updateOrientationOverlay();
  window.addEventListener("resize", () => this.updateOrientationOverlay());

}

updateOrientationOverlay() {
  const isMobile = window.innerWidth <= 850;
  const isPortrait = window.innerHeight > window.innerWidth;
  if (isMobile && isPortrait) {this.orientationOverlay.style.display = "flex";
  } else {this.orientationOverlay.style.display = "none";}
}
  
}